module.exports = __webpack_public_path__ + "img/ic_class_living-white.70f2c989.gif";